// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Qdq9","label":"styles_label__3v-lY"};